export const brandInfo = {
  name: '高柳家',
  nameJP: '高柳家',
  established: 1750,
  generation: 9,
  location: '京都市中京区',
  description: '高柳家是一个承载着深厚文化底蕴的家族品牌。自江户时代中期创立以来，高柳家始终以精湛的传统工艺、雅致的生活美学和坚定的文化传承为核心理念，历经九代人、超过二百七十年的薪火相传。从最初的木工匠坊，到如今涵盖家居、茶道、香道、花道等多元领域的综合性文化品牌，高柳家始终坚守"木有灵性，匠有心声"的家训精神。',
  mission: '在快速变化的时代中，守护并传承日本传统工艺的精髓，同时以当代视角重新诠释，让传统之美在现代生活中焕发新的生命力。',
  vision: '成为全球最受尊敬的传统工艺文化品牌，让每一位接触高柳家的人都能感受到匠心之美、文化之深、生活之雅。',
  values: [
    { title: '匠心精研', description: '对每一件作品倾注全部心力，追求极致的品质与细节。' },
    { title: '文化传承', description: '守护传统工艺的薪火，培养新一代匠人，让技艺永续传承。' },
    { title: '自然共生', description: '尊重自然的节奏与馈赠，使用天然材料，坚持可持续的工艺实践。' },
    { title: '生活美学', description: '将艺术融入日常，让每一天的生活都成为一场审美的修行。' },
  ],
  history: [
    { year: '1750年', event: '第一代家主高柳宗一郎在京都西阵创立木工匠坊。' },
    { year: '1820年', event: '第二代家主高柳宗助将工坊迁至现址，扩建为家族宅邸兼工坊。' },
    { year: '1895年', event: '第四代家主高柳源次郎引入西洋家具设计理念，开创"和洋折衷"风格。' },
    { year: '1948年', event: '第六代家主高柳健一开设工艺传习所，向社会开放招生。' },
    { year: '1965年', event: '高柳家作品首次入选"日本传统工艺展"，获得业界广泛认可。' },
    { year: '1985年', event: '联合发起成立"日本传统工艺传承联盟"。' },
    { year: '2000年', event: '第八代家主被认定为"重要无形文化财保持者"（人间国宝）。' },
    { year: '2010年', event: '首家品牌体验店"高柳の舎"在京都三条通开业。' },
    { year: '2015年', event: '受邀参加米兰设计周，迈出品牌国际化第一步。' },
    { year: '2018年', event: '第一家海外直营店在巴黎玛黑区开业。' },
    { year: '2024年', event: '高柳家线上商城上线，覆盖全球28个国家和地区。' },
  ],
  contact: {
    address: '日本京都市中京区三条通高倉西入ル',
    phone: '+81-75-XXX-XXXX',
    email: 'info@takayanagi-family.com',
    hours: '10:00 - 18:00（每周一定休）',
    wechat: '高柳家官方',
    weibo: '@高柳家官方',
  },
  stats: [
    { label: '传承世代', value: '9代', icon: 'ri-history-line' },
    { label: '创立年份', value: '1750年', icon: 'ri-calendar-line' },
    { label: '出口国家', value: '28+', icon: 'ri-global-line' },
    { label: '培养匠人', value: '120+', icon: 'ri-team-line' },
  ],
  testimonials: [
    {
      quote: '高柳家的作品让我第一次真正理解了什么是"匠心"。每一件器物都有温度，都有故事。',
      author: '山本隆一',
      role: '京都文化研究学者',
    },
    {
      quote: '作为设计师，我见过太多为了传统而传统的作品。高柳家不同，他们在传统中找到了与当代的连接点，这是非常了不起的。',
      author: 'Marc Dubois',
      role: '法国室内设计师',
    },
    {
      quote: '高柳家的茶具是我每天都使用的器物。它不仅是工具，更像是生活中的一位安静伴侣。',
      author: '林清婉',
      role: '资深茶道爱好者',
    },
    {
      quote: '我们在巴黎的店里展出了高柳家的作品后，法国顾客的反响超出预期。东方美学在西方同样有着巨大的感染力。',
      author: 'Sophie Laurent',
      role: '巴黎高端家居买手',
    },
  ],
};